import { ReactNode } from "react";
import { cn } from "@drpcrd/utils/shared";
import { Typography } from "../typography";

type Props = {
  centered?: boolean;
  pageIcon?: ReactNode;
  title?: string;
  titleSize?: "sm" | "base" | "xl";
  titleDescGapSize?: "sm" | "md"; // 100 & 300
  description?: ReactNode | string;
  descriptionColor?: "primary" | "neutral";
  badge?: ReactNode;
  className?: string;
};

/**
 * Header component for creator pages displaying title, description, and optional icons
 */
export const CreatorPageHeader = ({
  centered = false,
  pageIcon,
  title,
  titleSize = "xl",
  titleDescGapSize = "sm",
  description: Description,
  descriptionColor = "neutral",
  badge,
  className,
}: Props) => (
  <div className="flex w-full items-center justify-center">
    <div className={cn("my-2 flex grow flex-col", className)}>
      {/* Icon and Title Description */}
      <div className={cn("flex flex-col gap-2", centered && "items-center")}>
        {pageIcon}

        {/* Title and Description */}
        <div
          className={cn(
            "flex flex-col",
            centered && "items-center px-4 sm:px-6",
            titleDescGapSize === "sm" ? "gap-1!" : "gap-3!",
          )}
        >
          {(title || badge) && (
            <div className="relative flex w-full flex-col">
              {title && (
                <Typography
                  size={titleSize}
                  align={centered ? "center" : "left"}
                  weight="semibold"
                >
                  {title}
                </Typography>
              )}

              {badge && (
                <div className="absolute right-0 transition-all duration-200 ease-linear">
                  {badge}
                </div>
              )}
            </div>
          )}

          {Description &&
            (typeof Description === "string" ? (
              <Typography
                size="sm"
                align={centered ? "center" : "left"}
                color={descriptionColor}
                className="leading-2.75"
              >
                {Description}
              </Typography>
            ) : (
              <>{Description}</>
            ))}
        </div>
      </div>
    </div>
  </div>
);
